<template>
  <div class="mt-4">
    <div class="container" v-if="studio">
      <div
        class="row"
        v-if="getPurchasedProducts && getPurchasedProducts.length"
      >
        <div class="col-12">
          <div class="border p-4 rounded">
            <div class="row">
              <div
                class="col-12 d-flex flex-row align-items-center justify-content-between mb-4"
              >
                <h3 class="m-0">{{ $t('GENERAL.LINK.MY_PRODUCTS') }}</h3>
              </div>
              <div
                class="col-sm-6 col-md-3 px-3"
                v-for="product in getPurchasedProducts"
                :key="product.id"
              >
                <router-link
                  class="undecorated-router-link"
                  :to="{
                    name: 'studio-product',
                    params: { product_id: product.id },
                  }"
                >
                  <StudioProductCard :product="product" size="sm" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HMNoDataCard
        v-else
        :title="$t('PRODUCTS.TITLE.NO_PRODUCTS')"
        :description="$t('STUDIO.TEXT.NO_PRODUCTS_TEXT')"
        :toLabel="$t('STUDIO.BUTTON.BROWSE_PRODUCTS')"
        toRouteName="studio-shop"
      />
      <div
        class="row mt-4"
        id="class-cards-credits"
        v-if="punches && punches.length"
      >
        <div class="col-12">
          <div class="border p-4 rounded">
            <div class="row">
              <div class="col-12">
                <h3 class="mb-4">
                  {{ $t('STUDIO.TITLE.CLASS_CARD_CREDITS') }}
                </h3>
                <StudentClassCard class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="hasSolvedQuizzes">
        <div class="col-12">
          <div class="border p-4 rounded">
            <h3 class="mb-4">
              {{ $t('QUIZZES.TITLE.YOUR_QUIZ_SUBMISSIONS') }}
            </h3>
            <StudentSolvedQuizzesTable :items="solvedQuizzes" />
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-else>
      <HMSpinner></HMSpinner>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import RefreshData from '@/web/mixins/refreshData';
import { mapGetters } from 'vuex';
import StudioProductCard from '@/web/components/products/StudioProductCard';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import StudentSolvedQuizzesTable from '@/web/components/quizzes/StudentSolvedQuizzesTable';
import StudentClassCard from '@/web/components/shop/StudentClassCard';

export default Vue.extend({
  name: 'StudentProducts',
  components: {
    StudioProductCard,
    StudentSolvedQuizzesTable,
    StudentClassCard,
  },
  mixins: [RefreshData],
  data() {
    return {
      solvedQuizzes: [],
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      isOwner: 'studio/isOwner',
      punches: 'user/punches',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    sortedProducts() {
      if (!this.studio || !this.studio.products) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.studio.products.sort((p1, p2) => p1.position - p2.position);
    },
    getPurchasedProducts() {
      if (this.isOwner) return this.sortedProducts;
      return this.sortedProducts.filter(product => product.purchased);
    },
    hasSolvedQuizzes() {
      return this.solvedQuizzes?.length > 0;
    },
  },
  methods: {
    async loadData() {
      this.solvedQuizzes = await this.$store.dispatch(
        'studentSolvedQuiz/getSolvedQuizzes',
        {
          studioURL: this.studioURL,
        }
      );
    },
  },
  mounted() {
    this.loadData();
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

::v-deep .icon-container .icon {
  border-radius: $border-radius;
}

::v-deep .btn-container .add-button {
  border-radius: $border-radius;
  padding: 4px 8px;
}
</style>
